import { render } from "./EditProductView.vue?vue&type=template&id=7f55e8c1"
import script from "./EditProductView.vue?vue&type=script&lang=js"
export * from "./EditProductView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__